// Import Core
import React from "react";
import { Link } from "gatsby";
// Import Libraries
import { GatsbyImage, getImage } from "gatsby-plugin-image";
// Import Components
import Button from "../../ui/buttons/Button";
// Import Utils
import { usePlaceholderImage } from "../../../utils/useRandomPlaceholderImage";
import { getSlug } from "../../../utils/getSlug";
// Import configData
import configData from "../../../../configData.json";
import { convertAorAn } from "../../../utils/convertAorAn";

const StickyCta = ({
  country,
  expert,
  pageType,
  productType,
  productTitle,
  productDarwinId,
  depositOverride,
}) => {
  const { randomPlaceholderImage } = usePlaceholderImage();
  return (
    <div className="product-cta">
      <div className="cta-box">
        <div className="cta-section-title">
          <h3 className="red">{`Speak to ${convertAorAn(
            country
          )} ${country} specialist`}</h3>
          <p>{configData.product_expert.text}</p>
        </div>
        {expert && (
          <div className="person-blurb">
            <Link to={getSlug(expert)}>
              {expert.thumbnail ? (
                <GatsbyImage
                  image={getImage(expert.thumbnail.asset)}
                  alt="expert.title"
                  className="person-pic"
                />
              ) : (
                <img
                  src={randomPlaceholderImage}
                  alt=""
                  className="person-pic"
                />
              )}
            </Link>

            <div className="person-info">
              <Link to={getSlug(expert)}>
                <h5 className="alt">{expert.title}</h5>
              </Link>
              <p>{expert.jobTitle}</p>
              {/* {expert.email && (
								<a
									href={`mailto:${expert.email}`}
									className='email'>
									{expert.email}
								</a>
							)} */}
            </div>
          </div>
        )}
        <a href={configData.enquiry.phone.link} className="person-link">
          <Button
            size="md"
            btnStyle="outline"
            className="person-btn"
            value={configData.enquiry.phone.alt_text}
            clickHandler={false}
            isDisabled={false}
          />
        </a>
      </div>
      {pageType === "product" && productType !=="event" && (
        <Link
          to={configData.enquiry.enquiry.link}
          className="enquiry-link"
          state={{
            productType: productType,
            productTitle: productTitle,
            productDarwinId: productDarwinId,
            country: country,
            depositOverride: depositOverride,
            isBooking: false,
          }}
        >
          <Button
            size="md"
            btnStyle="outline"
            className="enquiry-btn"
            value={configData.enquiry.enquiry.text}
            clickHandler={false}
            isDisabled={false}
          />
        </Link>
      )}
    </div>
  );
};

export default StickyCta;
